import { render, staticRenderFns } from "./AccommodationCard.vue?vue&type=template&id=3ac0bff3&"
import script from "./AccommodationCard.vue?vue&type=script&lang=js&"
export * from "./AccommodationCard.vue?vue&type=script&lang=js&"
import style0 from "./AccommodationCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports